// extracted by mini-css-extract-plugin
module.exports = {"card":"maincard_card__1vZsD","card__details":"maincard_card__details__1RPlF","flip":"maincard_flip__1hwgH"};